export default "__VITE_ASSET__fbe0619a__"